import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { Toast } from '@shared/ui/toast/toast';
import { ModalAdminDataProps } from './types';
import { useCompleteOrderMutation, useRejectOrderMutation } from '@entities/order/api/order-api';
import { AdditionalModalAdminView } from '../additional-modal-admin-view/additional-modal-admin-view';
import { useOrderSharedQuery } from '@entities/order/libs/hooks/use-order-shared-query/use-order-shared-query';
import { DeclineFormKeys } from '../additional-modal-admin-view/types';

export const ModalAdminData: React.FC<ModalAdminDataProps> = ({
    orderId,
    isModalComplete,
    setIsModalComplete,
    isModalReject,
    setIsModalReject,
}) => {
    const [completeOrder, completeOrderResult] = useCompleteOrderMutation();
    const [rejectOrder, rejectOrderResult] = useRejectOrderMutation();
    const [, , resetOrder] = useOrderSharedQuery(orderId || 0);

    const handleCompleteOrder = async (fields: Record<DeclineFormKeys, string>) => {
        await completeOrder({
            id: orderId || 0,
            comment: fields[DeclineFormKeys.Comment] || '',
        });
    };

    const handleRejectOrder = async (fields: Record<DeclineFormKeys, string>) => {
        await rejectOrder({
            id: orderId || 0,
            comment: fields[DeclineFormKeys.Comment] || '',
        });
    };

    useEffect(() => {
        if (rejectOrderResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Сделка отклонена'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            rejectOrderResult.reset();
            setIsModalReject(false);
            resetOrder();
        } else if (rejectOrderResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={'Не удалось отклонить сделку'}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            rejectOrderResult.reset();
            setIsModalReject(false);
            resetOrder();
        }
    }, [rejectOrderResult]);

    useEffect(() => {
        if (completeOrderResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Сделка согласована'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            completeOrderResult.reset();
            setIsModalComplete(false);
            resetOrder();
        } else if (completeOrderResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={'Не удалось согласовать сделку'}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            completeOrderResult.reset();
            setIsModalComplete(false);
            resetOrder();
        }
    }, [completeOrderResult]);

    return (
        <>
            <AdditionalModalAdminView
                isShow={isModalComplete}
                headerTitle='Подтверждение оплаты'
                text='Вы действительно хотите подтвердить оплату?'
                showPreloader={completeOrderResult.isLoading}
                onClose={() => setIsModalComplete(false)}
                onSubmit={handleCompleteOrder}
            />
            <AdditionalModalAdminView
                isShow={isModalReject}
                headerTitle='Отмена оплаты'
                text='Вы действительно хотите отменить оплату?'
                showPreloader={rejectOrderResult.isLoading}
                onClose={() => setIsModalReject(false)}
                onSubmit={handleRejectOrder}
            />
        </>
    );
};
